/*=====================================
    PageButton

    Author: Ac
    CreateTime: 2018 / 10 / 04
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GlobalStyle } from 'stylecomponents';

/*--------------------------
    Styled
--------------------------*/
const Button = GlobalStyle.BasicBlock.extend`
    background-color: ${props => props.isActive? '#F75C2F' : '#f3f3f3'};
    color: ${props => props.isActive? '#FFF' : '#7D8995'};
    font-size: 14px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 2px;
    cursor: pointer;
`;
/*--------------------------
    Main Component
--------------------------*/
class PageButton extends Component {

    static propTypes = {
        num: PropTypes.number.isRequired,
        changePage: PropTypes.func.isRequired,
        isActive: PropTypes.bool,
    };

    changePage = () => {
        const { num } = this.props;
        this.props.changePage(num);
    }

    render() {
        return (
            <Button
                onClick={this.changePage}
                isActive={this.props.isActive}
            >
                {this.props.num}
            </Button>
        );
    }
}

/*--------------------------
    Export
--------------------------*/
export default PageButton;